module.exports = __webpack_public_path__ + "static/Truck12-68c588a4122a35a9b17bf1eefca3c540.png";